import React from 'react'
import PlacesAutocomplete from 'react-places-autocomplete'

import './PlaceField.css'

const PlaceField = ({
  className,
  input,
  onSelect,
  placeholder,
  required
}) => (
  <PlacesAutocomplete
    classNames={{
      autocompleteContainer: 'search-autocomplete-container',
      autocompleteItem: 'search-autocomplete-item',
      autocompleteItemActive: 'search-autocomplete-item--active',
      googleLogoContainer: 'google-logo-container',
      googleLogoImage: 'google-logo-image',
      input: className,
      root: 'search-autocomplete-root',
    }}
    debounce={400}
    highlightFirstSuggestion={true}
    inputProps={{
      placeholder,
      required,
      type: 'search',
      ...input
    }}
    onEnterKeyDown={onSelect}
    onSelect={onSelect}
    options={{
      componentRestrictions: { country: 'us' },
      types: ['address'],
    }}
  />
)

export default PlaceField


// WEBPACK FOOTER //
// ./src/components/PlaceField/PlaceField.js